import React, { useEffect, useState } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import Layout from './components/layout/Layout'
import Login from './pages/Auth/Login'
import ComfirmPassword from './pages/Auth/ComfirmPassword'
import Forgetpassword from './pages/Auth/ForgetPassword'
import SessionExpiredModal from './pages/Auth/SessionExpiredModal'
import Register from './pages/Auth/Register'
import AdminDashboard from './pages/Dashboard/AdminDashboard'
import EducatorDashboard from './pages/Dashboard/EducatorDashboard'
import StudentDashboard from './pages/Dashboard/StudentDashboard'
import FamilyDashboard from './pages/Dashboard/FamilyDashboard'
import ApplicationsList from './pages/Applications/ApplicationsList'
import ApplicationDetail from './pages/Applications/ApplicationDetail'
import ProgressOverview from './pages/Progress/ProgressOverview'
import EducatorProgressbar from './pages/Progress/EducatorProgressbar'
import AdminProgressbar from './pages/Progress/AdminProgressbar'
import FamilyProgressbar from './pages/Progress/FamilyProgressbar'
import StudentProgressbar from './pages/Progress/StudentProgressbar'
import AddNotesGrades from './pages/AddNotesGrades/AddNotesGrades'
import StudentManagement from './pages/Management/StudentManagement'
import UserManageEducator from './pages/Management/UserManageEducator'
import UserProfile from './pages/Profile/UserProfile'
import UserManagement from './pages/Management/UserManagement'
import ApplicationManagement from './pages/Management/ApplicationManagement'
import ProtectedRoute from './router/ProtectedRoute'
import StudentApplication from './pages/Applications/StudentApplication'
import StudentApplicationById from './pages/Applications/StudentApplicationById'
import EducatorApplication from './pages/Applications/EducatorApplication'
import AdminDataAccessControl from './pages/DataAccessControl/AdminDataAccessControl'
import AdminProgressAndAnalytics from './pages/Progress/AdminProgressAndAnalytics'
import LandingPage from './pages/LandingPage/LandingPage'
import UserMangenetStudent from './pages/Management/UserMangenetStudent'
import helpers from './utils/helpers'
import ResetPassword from './pages/Auth/ResetPassword'
import { authService } from './services/authService'


function App() {
  const { user, loading, getUserRole } = useAuth();
  const [userRole, setUserRole] = useState({})
  const [permissions, setPermissions] = useState({
    create: true,
    edit: true,
    view: true,
    export: true,
    updateApplicationProgress: true,
    downloadAttachment: true,
    deleteSingle: true,
    deleteMultipal: true,
  })
  const userToken = helpers.getSession('token')
  const location = useLocation();
  let urlPath = location?.pathname.replace(/^\//, "")

  // Same fields for admin application and educator application in reponse
  let application = {
    create: true,
    edit: true,
    view: true,
    export: true,
    updateApplicationProgress: true,
    downloadAttachment: true,
    deleteSingle: true,
    deleteMultipal: true,
  }
  let userper = {
    create: true,
    edit: true,
    view: true,
    deleteSingle: true,
    deleteMultipalApps: true,
  }

  // Same fields for admin, educator, and family
  let progressAnalytics = {
    export: true,
  }
  let addNotesAndGrades = {
    deleteMultipal: true,
    saveAllChanges: true,
    singleSave: true,
    draftList: true,
  }
  let studentManagement = {
    enrollNewStudent: true,
    enrollandDropStudent: true
  }
  let studentApplication = {
    view: true
  }

  useEffect(() => {
    if (userToken) {
      userRolee()
    }
  }, [userToken])

  // useEffect(() => {
  //   getModuleWisePermissions()
  // },[urlPath])

  async function userRolee() {
    try {
      const response = await getUserRole()
      if (response?.success) {
        setUserRole(response?.data)
      } else {
        setUserRole({})
        console.error('Failed to fetch user roles')
      }
    } catch (error) {
      console.error('Error fetching user roles:', error)
    }
  }

  async function getModuleWisePermissions() {
    try {
      let data = JSON.stringify({
        'route': urlPath
      })
      const response = await authService.modulePermission(data)
      if (response?.success) {
        setPermissions(response?.data)
      } else {
        setPermissions({})
        console.error('Failed to fetch permissions')
      }
    } catch (error) {
      console.error('Error fetching permissions:', error)
    }
  }


  const getDashboardComponent = () => {
    switch (userRole?.role_name) {
      case 'Admin':
        return AdminDashboard
      case 'Educator':
        return EducatorDashboard
      case 'Student':
        return StudentDashboard
      case 'Family':
        return FamilyDashboard
      default:
        return StudentDashboard
    }
  }

  const DashboardComponent = getDashboardComponent()

  // ✅ Role-based progressbar
  const getProgressbarComponent = () => {
    switch (userRole?.role_name) {
      case 'Admin':
        return AdminProgressbar
      case 'Educator':
        return EducatorProgressbar
      case 'Student':
        return StudentProgressbar
      case 'Family':
        return FamilyProgressbar
      default:
        return StudentProgressbar
    }
  }

  const ProgressbarComponent = getProgressbarComponent()

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login"
        element={userToken ? <Navigate to="/dashboard" replace /> : <Login />}
      />
      {/* <Route path="/login"
        element={<Login />}
      /> */}
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route path="/forget-password" element={<Forgetpassword />} />
      <Route path="/comfirm-password" element={<ComfirmPassword />} />
      <Route path="/SessionExpiredModal" element={<SessionExpiredModal />} />
      <Route
        path="/register"
        element={!userToken ? <Register /> : <Navigate to="/dashboard" replace />}
      />

      {/* Protected routes */}
      <Route path="/" element={<ProtectedRoute userRole={userRole}><Layout userRole={userRole} /></ProtectedRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />


        {/* Landing */}
        <Route path="landing" element={<LandingPage />} />

        {/* Dashboards */}
        <Route
          path="dashboard"
          element={DashboardComponent ? <DashboardComponent /> : <Navigate to="/login" replace />}
        />


        {/* Applications */}
        <Route path="applications" element={
          <ProtectedRoute userRole={userRole} allowedRoles={['Admin']} >
            <ApplicationsList userRole={userRole} permission={application} />
          </ProtectedRoute>} />

        <Route path="applications/:id" element={
          <ProtectedRoute userRole={userRole} allowedRoles={['Admin', 'Educator']}>
            <ApplicationDetail userRole={userRole} permission={application} />
          </ProtectedRoute>
        } />

        <Route path="myapplications"
          element={
            <ProtectedRoute userRole={userRole} allowedRoles={['Student', 'Family']}>
              <StudentApplication userRole={userRole} permission={studentApplication} />
            </ProtectedRoute>
          }
        />

        <Route path="myapplications/:id"
          element={
            <ProtectedRoute userRole={userRole} allowedRoles={['Student', 'Family']}>
              <StudentApplicationById userRole={userRole} />
            </ProtectedRoute>
          } />

        <Route path="educatorapplications"
          element={
            <ProtectedRoute userRole={userRole} allowedRoles={['Educator']}>
              <EducatorApplication permission={application} />
            </ProtectedRoute>
          } />

        {/* Progress */}
        <Route path="progress" element={<ProgressOverview />} />

        <Route path="progressbar"
          element={
            <ProtectedRoute userRole={userRole} allowedRoles={['Educator', 'Family']}>
              <ProgressbarComponent permission={progressAnalytics} />
            </ProtectedRoute>
          }
        />
        <Route path="educatorprogressandandanalytics"
          element={
            <ProtectedRoute userRole={userRole} allowedRoles={['Educator']}>
              <EducatorProgressbar permission={progressAnalytics} />
            </ProtectedRoute>
          }
        />

        <Route path="trackprogress" element={
          <ProtectedRoute userRole={userRole} allowedRoles={['Student']}>
            <StudentProgressbar />
          </ProtectedRoute>
        } />

        {/* Profile */}
        <Route path="profile" element={<UserProfile />} />

        <Route path="addnotesgrades"
          element={
            <ProtectedRoute userRole={userRole} allowedRoles={['Educator']}>
              <AddNotesGrades permission={addNotesAndGrades} />
            </ProtectedRoute>
          } />

        {/* Admin Only Routes */}
        <Route
          path="management/users"
          element={
            <ProtectedRoute userRole={userRole} allowedRoles={['Admin']}>
              <UserManagement permission={userper} />
            </ProtectedRoute>
          }
        />
        <Route
          path="management/applications"
          element={
            <ProtectedRoute userRole={userRole} allowedRoles={['Admin']}>
              <ApplicationManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="dataaccesscontrol"
          element={
            <ProtectedRoute userRole={userRole} allowedRoles={['Admin']}>
              <AdminDataAccessControl />
            </ProtectedRoute>
          }
        />
        <Route
          path="reports"
          element={
            <ProtectedRoute userRole={userRole} allowedRoles={['Admin', 'Educator']}>
              <AdminProgressAndAnalytics permission={progressAnalytics} />
            </ProtectedRoute>
          }
        />

        {/* Admin & Educator Routes */}
        <Route
          path="progressandanalytics"
          element={
            <ProtectedRoute userRole={userRole} allowedRoles={['Admin', 'Educator']}>
              <AdminProgressAndAnalytics permission={progressAnalytics} />
            </ProtectedRoute>
          }
        />

        {/* Educator Only Routes */}
        <Route
          path="classes"
          element={
            <ProtectedRoute userRole={userRole} allowedRoles={['Educator']}>
              <StudentManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="assignments"
          element={
            <ProtectedRoute userRole={userRole} allowedRoles={['Educator', 'Student']}>
              <AddNotesGrades />
            </ProtectedRoute>
          }
        />

        {/* Student Only Routes */}
        <Route
          path="achievements"
          element={
            <ProtectedRoute userRole={userRole} allowedRoles={['Student']}>
              <UserProfile />
            </ProtectedRoute>
          }
        />

        {/* Family Only Routes */}
        <Route
          path="students"
          element={
            <ProtectedRoute userRole={userRole} allowedRoles={['Family']}>
              <StudentProgressbar />
            </ProtectedRoute>
          }
        />
        <Route
          path="messages"
          element={
            <ProtectedRoute userRole={userRole} allowedRoles={['Family', 'Educator']}>
              <UserProfile />
            </ProtectedRoute>
          }
        />

        {/* Legacy Routes - keeping for backward compatibility */}
        <Route path="studentmanagement" element={
          <ProtectedRoute userRole={userRole} allowedRoles={['Educator']}>
            <StudentManagement permission={studentManagement} />
          </ProtectedRoute>
        } />
        <Route path="userProfile/:id" element={
          <ProtectedRoute userRole={userRole} allowedRoles={['Admin']}>
            <UserManageEducator permission={userper} />
          </ProtectedRoute>} />

        <Route path="userProfileStudent" element={<UserMangenetStudent />} />

      </Route>

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  )
}

export default App
